import { ConfirmPopupDesignTokens } from '@primeuix/themes/aura/confirmpopup';

export const confirmPopupTokens: ConfirmPopupDesignTokens = {
  root: {
    background: '{overlay.popover.background}',
    borderColor: '{overlay.popover.border.color}',
    borderRadius: '{overlay.popover.border.radius}',
    color: '{overlay.popover.color}',
    shadow: '{overlay.popover.shadow}',
    gutter: '10px',
    arrowOffset: '1.25rem',
  },
  content: {
    padding: '{overlay.popover.padding}',
    gap: '1rem',
  },
  icon: {
    size: '1.5rem',
    color: '{overlay.popover.color}',
  },
  footer: {
    gap: '0.5rem',
    padding: '0 {overlay.popover.padding} {overlay.popover.padding} {overlay.popover.padding}',
  },
};
